import { Owner } from 'api'
import { ShareholderActions } from './shareholderActions'
import { ReactElement } from 'react'
import React from 'react'

interface IndividualShareholderNodeProps {
  shareholder: Owner
  editShareholder: (shareholder: Owner) => void
  addShareholderToOwner: (shareholder: Owner) => void
  isRoot: boolean
}

export const IndividualShareholderNode = ({
  shareholder,
  editShareholder,
  addShareholderToOwner,
  isRoot,
}: IndividualShareholderNodeProps): ReactElement => {
  const fullName = `${shareholder.firstName} ${shareholder.lastName}`
  const address =
    shareholder.addressesAttributes && shareholder.addressesAttributes.length > 0
      ? shareholder.addressesAttributes[0]
      : undefined
  return (
    <div className={isRoot ? 'mb-2' : 'ml-4 mb-2'}>
      <div>
        <strong>
          {shareholder.ownerCategory}: {fullName}
        </strong>{' '}
        ({shareholder.share}%)
        <ShareholderActions
          editShareholder={editShareholder}
          addShareholderToOwner={addShareholderToOwner}
          shareholder={shareholder}
        />
        <br /> <span className="text-muted">DOB: {shareholder.dateOfBirth}</span>
        <div>
          {address ? (
            <div className="text-muted">
              {address.address1}, {address.city}, {address.provinceCode} {address.postalCode}
            </div>
          ) : (
            'Address not provided'
          )}
        </div>
      </div>
    </div>
  )
}
